import { Injectable } from '@angular/core';
import { of, Observable } from 'rxjs';
import { share, catchError } from 'rxjs';
import { HomepageSelectionHttpService } from './homepage-selection-http.service';

@Injectable()
export class HomepageManagerService {

  constructor(
    private readonly homepageHttpService: HomepageSelectionHttpService
  ) { }

  getHomepage(): Observable<string> {
    return this.homepageHttpService
      .getHomepage()
      .pipe(
        share(),
        catchError(() => {
          console.error('cannot fetch homepage');
          return of(undefined);
        }));
  }

  setHomepage(url: string): Observable<void> {
    return this.homepageHttpService.setHomepage(url);
  }
}
